<script lang="ts">
  export let postcode :string;
  export let isValid: boolean = false;

  import _ from "lodash";

  $: _postcode = postcode;

  const onChangePostcode = _.debounce((event :any) => {
    lookupPostcode(event.target);
  }, 300);

  function lookupPostcode(target :any) {
    const input = target.value;

    if (input.length >= 5) {
      fetch(`https://api.postcodes.io/postcodes/${input}/autocomplete`)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          if (data.result && data.result.length == 1) {
            _postcode = data.result[0];
            postcode = _postcode;
            isValid = true;
          }
          else {
            isValid = false;
          }
          console.log(data.result);
        });
    }
  }
</script>

<input
  bind:value={_postcode}
  class="input"
  placeholder="postcode"
  style="font-size:1rem;"
  on:input={onChangePostcode} />
